import {
  PTL_FREIGHT_UPLOAD,
} from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  response: null,
  loading: false
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case PTL_FREIGHT_UPLOAD[REQUEST]:
      return { ...state, response: null, loading: true };
    case PTL_FREIGHT_UPLOAD[SUCCESS]:
      return { ...state, response: action.response, loading: false };
    case PTL_FREIGHT_UPLOAD[FAILURE]:
      return { ...state, response: null, loading: false };
    default:
      return state;
  }
}

export const ptlFreightUploadReducer = (state) => state.ptlFreightUpload.response;